export default __webpack_public_path__ + "static/illustration-content-desc.url-66565852bb61ae19bff24974a9290df3.svg";